<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="w-full min-h-screen overflow-x-auto">

    <div class="text-base font-semibold dark:text-white whitespace-nowrap">{{regCode}} {{centerName}}</div>

    <div class="flex flex-row items-center justify-between gap-4">
        <div>
            <p class="text-base font-semibold dark:text-white whitespace-nowrap ">
                All ({{ totalItems < 10 ? '0' + totalItems : totalItems }}) </p>
        </div>
        <div class="flex flex-row items-center justify-end gap-5 ">

            <i class="fa-solid text-[#4A4A4A] fa-list text-lg dark:text-white ml-5"></i>

            <p class="text-[#4A4A4A] dark:text-white whitespace-nowrap">Filter By</p>

            <div class="relative w-56 custom-role-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectRole" class="hidden" (change)="applyRoleFilters()">
                    <option value="Distribution Centre Manager">Distribution Centre Manager</option>
                    <option value="Distribution Officer">Distribution Officer</option>
                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleRoleDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer">
                        <span>{{ selectRole || 'Role' }}</span>
                        <div class="flex items-center">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectRole" (click)="clearRoleFilter($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isRoleDropdownOpen || !selectRole"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isRoleDropdownOpen"
                                [class.fa-angle-up]="isRoleDropdownOpen"></i>
                        </div>
                    </div>
                </div>

                <!-- Custom dropdown options -->
                <div *ngIf="isRoleDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of roleDropdownOptions" (click)="selectRoleOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div *ngIf="isDropdownOpen" class="dropdown-backdrop" (click)="isDropdownOpen = false"></div> -->
            <div class="relative w-40 custom-status-dropdown-container">
                <!-- Hidden native select -->
                <select [(ngModel)]="selectStatus" class="hidden" (change)="applyStatusFilters()">
                    <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value=""></option>
                    <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Approved">Approved</option>
                    <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Not Approved">Not Approved
                    </option>
                    <option class="hover:bg-gray-300 dark:hover:bg-gray-300" value="Rejected">Rejected</option>
                </select>

                <!-- Custom dropdown trigger -->
                <div class="border-[1.8px] border-[#828282] rounded-xl dark:bg-[#292929] text-textLight dark:text-textDark"
                    (click)="toggleStatusDropdown()">
                    <div class="flex flex-row justify-between items-center px-3 py-2 cursor-pointer ">
                        <span>{{ selectStatus || 'Status' }}</span>
                        <div class="flex items-center ">
                            <!-- X icon (shown ONLY when option is selected) -->
                            <i *ngIf="selectStatus" (click)="clearStatusFilter($event)"
                                class="fa-solid fa-xmark text-lg text-[#828282] mr-2 hover:text-[#555] dark:hover:text-[#aaa] cursor-pointer"></i>

                            <!-- Arrow icon (shown when EITHER: dropdown is open OR no selection exists) -->
                            <i *ngIf="isStatusDropdownOpen || !selectStatus"
                                class="fa-solid text-lg text-[#828282] transition-transform duration-200"
                                [class.fa-angle-down]="!isStatusDropdownOpen"
                                [class.fa-angle-up]="isStatusDropdownOpen"></i>
                        </div>
                    </div>
                </div>

                <!-- Custom dropdown options -->
                <div *ngIf="isStatusDropdownOpen"
                    class="absolute z-10 w-full mt-1 bg-white dark:bg-[#292929] rounded-xl shadow-lg border border-[#828282] overflow-hidden">
                    <div class="">
                        <div *ngFor="let option of statusDropdownOptions" (click)="selectStatusOption(option)"
                            class="px-3 py-2 hover:bg-gray-300 dark:text-textDark dark:hover:bg-gray-600 cursor-pointer flex items-center">
                            <span class="flex-grow">{{ option }}</span>
                            <i
                                class="fa-solid fa-hand-pointer ml-2 text-[#828282] opacity-0 group-hover:opacity-100"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="flex items-center mr-5 text-[#95A1AC] rounded-full  px-4 py-2 w-92 bg-[#F1F1F1] dark:bg-[#292929]">
                <input type="text" placeholder="Search by EMP ID, Name..." [(ngModel)]="searchText"
                    (keyup.enter)="onSearch()" (keyup.esc)="offSearch()"
                    class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                    (click)="onSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                    </svg>
                </button>
                <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="offSearch()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>

        </div>
    </div>

    <div *ngIf="!hasData"
        class="flex flex-col items-center w-full h-screen px-10 py-7 bg-tileLight dark:bg-[#363636] dark:text-textDark mt-6">
        <p class="text-[#494949] my-6 dark:text-textDark">--No Officers Availabale--</p>
        <img src="assets/images/NoData.png" alt="No Data" class="w-20 h-20 dark:text-textDark" />
    </div>

    <div *ngIf="hasData"
        class="min-w-max overflow-hidden mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full min-w-max divide-y-2 ">
            <thead class=" text-[#4B5563] dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                <tr>
                    <th class="px-2 py-3 text-left text-sm font-medium">No</th>
                    <th class="px-3 py-3 text-left text-sm font-medium">EMP ID</th>
                    <th class="px-3 py-3 text-left text-sm font-medium">First Name</th>
                    <th class="px-3 py-3 text-left text-sm font-medium">Last Name</th>
                    <th class="px-3 py-3 text-left text-sm font-medium" *ngIf="logingRole ==='Collection Centre Head'">
                        Centres</th>
                    <th class="px-3 py-3 text-left text-sm font-medium ">Role</th>
                    <th class="px-3 py-3 text-center text-sm font-medium ">Status</th>
                    <th class="px-3 py-3 text-center text-sm font-medium">Phone -1</th>
                    <th class="px-3 py-3 text-center text-sm font-medium">NIC</th>
                    <th class="px-3 py-3 text-center text-sm font-medium"></th>
                </tr>
            </thead>
            <tbody class="bg-white text-[#000000] dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr *ngFor="let item of OfficerArr | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  };  let i = index">
                    <td class="px-2 py-4 text-sm text-[#000000] font-medium dark:text-gray-300 ">
                        {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1) :
                            (((page - 1) * itemsPerPage) + i + 1) }} </td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300">{{item.empId}}</td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300">
                        {{item.firstNameEnglish}}</td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300">{{item.lastNameEnglish}}
                    </td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300"
                        *ngIf="logingRole ==='Collection Centre Head'">{{item.centerName}}</td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300">{{item.jobRole}}</td>
                    <td class="px-3 py-4 text-center">
                        <div class="flex justify-center items-center"
                            [style.cursor]="logingRole === 'Distribution Centre Head' ? 'pointer' : 'default'"
                            (click)="logingRole === 'Distribution Centre Head' && openPopup(item)">

                            <span *ngIf="item.status === 'Approved'"
                                class="inline-block w-28 py-1 text-center bg-[#C8E0FF] text-[#415CFF] text-sm font-medium rounded-md shadow-md">
                                Approved
                            </span>

                            <span *ngIf="item.status === 'Not Approved'"
                                class="inline-block w-28 py-1 text-center bg-[#F8FFA6] text-[#A8A100] text-sm font-medium rounded-md shadow-md">
                                Not Approved
                            </span>

                            <span *ngIf="item.status === 'Rejected'"
                                class="inline-block w-28 py-1 text-center bg-[#FFB9B7] text-[#D16D6A] text-sm font-medium rounded-md shadow-md">
                                Rejected
                            </span>

                        </div>
                    </td>

                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300 text-center">
                        {{ item.phoneNumber01 ? item.phoneCode01 + item.phoneNumber01 : 'N/A' }}
                    </td>
                    <td class="px-3 py-4 text-sm text-[#000000] font-medium dark:text-gray-300 text-center">{{item.nic}}
                    </td>
                    <td class="px-3 py-4 text-sm text-gray-900 dark:text-gray-300 text-center">
                        <button class="text-gray-400 hover:text-gray-600 px-2" (click)="navigateToProfile(item.id)">
                            <i class="fa-regular fa-file text-lg text-gray-600"></i>
                        </button>

                        <button class="text-[#415CFF] hover:text-blue-500 px-2" [ngClass]="{
                                'text-gray-400 hover:text-gray-600': (logingRole ==='Distribution Centre Manager' && (item.jobRole === 'Distribution Centre Manager'))
                              }"
                            (click)="(logingRole ==='Distribution Centre Manager' && (item.jobRole === 'Distribution Centre Manager')) ? '' : navigateToEdit(item.id)">
                            <i class="fa-solid fa-pen-to-square text-lg"></i>
                        </button>
                        <button class="text-[#FF415C] hover:text-red-500 px-2"
                            (click)="(logingRole ==='Distribution Centre Manager' && item.jobRole === 'Distribution Centre Manager') ? '' : deleteCollectionOfficer(item.id)">
                            <i class="fa-solid fa-trash text-lg"></i>
                        </button>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="hasData" class="flex justify-end items-center my-5 mr-5 pt-3 dark:bg-[#262f45] text-right">
        <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
            [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
            [screenReaderCurrentLabel]="'Youre on page'">
        </pagination-controls>
    </div>

</div>